import COUNTRIES from '../countries.translations'

import type { Metal } from './types'
import translations from './zirconium.content'

const t = translations
const dir = '/mine-my-phone/images/metals/zirconium'

export const zirconium: Metal = {
  id: 37,
  slug: 'zirconium',
  name: t.name,
  symbol: 'Zr',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Eneabba, zirconium mine (Australia)',
      region: t.mine0Region,
      slug: 'eneabba',
      coordinates: [115.27, -29.82],
    },
    {
      name: 'Richards Bay, zirconium mine (South Africa)',
      region: t.mine1Region,
      slug: 'richards-bay',
      coordinates: [32.05, -28.78],
    },
    {
      name: 'Jacupiranga, zirconium mine (Brazil)',
      region: t.mine2Region,
      slug: 'jacupiranga',
      coordinates: [-48, -24.69],
    },
    {
      name: 'North Stradbroke Island, zirconium mine (Australia)',
      region: t.mine3Region,
      slug: 'north-stradbroke-island',
      coordinates: [153.42, -27.5],
    },
    {
      name: 'Matam, zirconium mine (Senegal)',
      region: t.mine4Region,
      slug: 'matam',
      coordinates: [-13.25, 15.66],
    },
    {
      name: 'Ceduna, zirconium mine (Australia)',
      region: t.mine5Region,
      slug: 'ceduna',
      coordinates: [133.67, -32.13],
    },
    {
      name: 'Moma, zirconium mine (Mozambique)',
      region: t.mine6Region,
      slug: 'moma',
      coordinates: [39.64, -16.53],
    },
    {
      name: 'Wenchang, zirconium mine (China)',
      region: t.mine7Region,
      slug: 'wenchang',
      coordinates: [110.75, 19.55],
    },
  ],
  countries: [
    { name: COUNTRIES.australia, percent: 33 },
    { name: COUNTRIES.southAfrica, percent: 20 },
    { name: COUNTRIES.mozambique, percent: 11 },
    { name: COUNTRIES.china, percent: 7 },
    { name: COUNTRIES.senegal, percent: 3.5 },
  ],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 2, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
      ],
    },
  },
}
